import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const updateMessage = async (payload, setLoading, setRefresh) => {
  try {
    const result = await http.post(AUTH_ROUTES.UPDATE_SUPPORT, payload);
    console.log(result, "support");
    setLoading(false)
    setRefresh((prev)=>!prev);
    successNotifier("Message successfully sent");
  } catch (e) {
    console.log(e.response, "support error");
    setLoading(false);
    errorNotifier(
      e?.response?.data?.data ||
      e?.response?.data?.message ||
      "Failed to send message. Please try again."
    );
  }
};

